export default __webpack_public_path__ + "static/media/sequelize.49ad3c7d.svg";